
export default () => {
  return {
    stack: [],
    home: null,
    direction: 'right',
    views: [],
    currentView: {},
    savedReport: false,
    sharedReport: false,
    feedbackReport: false,
    linkedReport: false
  }
}
